import { inject, Injectable } from '@angular/core';
import { Video } from './video.model';
import { Observable, shareReplay } from 'rxjs';
import { MemberQuery } from '../account/member/member.query';
import { ApiService } from '../shared/services/core/api.service';

@Injectable({ providedIn: 'root' })
export class VideoService {
  private requestCache = new Map<number, Observable<Video>>();
  private readonly api = inject(ApiService);
  private readonly memberQuery = inject(MemberQuery);

  getVideo(videoId: number): Observable<Video> {
    const cachedRequest = this.requestCache.get(videoId);
    if (cachedRequest) {
      return cachedRequest;
    }

    const clubId = this.memberQuery.getUserContext()?.clubId;
    const request$ = this.api.getAnySingle<Video>(`content/video/${clubId}?videoId=${videoId}`).pipe(
      shareReplay({
        bufferSize: 1,
        refCount: false,
      })
    );

    this.requestCache.set(videoId, request$);
    return request$;
  }
}
